export const CHART_PADDING = { top: 20, right: 60, bottom: 40, left: 8 };
export const CHART_PADDING_MOBILE = { top: 20, right: 48, bottom: 22, left: 0 };
export const CHART_PADDING_TOP_ENHANCED = 48;
export const VOLUME_HEIGHT_RATIO = 0.15;
export const Y_AXIS_TICKS = 5;

export const DAILY_MAX_DOMAIN_US_STOCKS = 78;
export const DAILY_MAX_DOMAIN_EU_STOCKS = 102;
export const DAILY_FX_DOMAIN = 288;

export const CHART_WIDTH = 1200;
export const CHART_HEIGHT_WEB = 334;
export const CHART_HEIGHT_MOBILE = 296;
